import { LettersPageState, MgState } from '@types';
import { createSelector } from 'reselect';
import { CompaniesEnum, LangEnum, SubmissionTypes } from '@enums';

export const lettersPageSelector = (store: MgState): LettersPageState => store.lettersPage;

export const lettersPageFiltersSubmissionTypeSelector = createSelector(
  [lettersPageSelector],
  (lettersPageSelector) => lettersPageSelector.filters.submissionType
);

export const lettersPageFiltersCompaniesSelector = createSelector(
  [lettersPageSelector],
  (lettersPageSelector) =>
    lettersPageSelector.filters.company || [CompaniesEnum.Vention, CompaniesEnum.Itechart]
);

export const lettersPageFiltersLanguageSelector = createSelector(
  [lettersPageSelector],
  (lettersPageSelector) => lettersPageSelector.filters.lang || LangEnum.ALL
);

export const lettersFiltersHasChanged = createSelector(
  [lettersPageSelector],
  (lettersPageSelector) => {
    return (
      lettersPageSelector.filters.submissionType !== SubmissionTypes.All ||
      (lettersPageSelector.filters.company &&
        !lettersPageSelector.filters?.company.includes(CompaniesEnum.Itechart)) ||
      (lettersPageSelector.filters.company &&
        !lettersPageSelector.filters?.company.includes(CompaniesEnum.Vention)) ||
      lettersPageSelector.filters.groupId ||
      lettersPageSelector.filters.title ||
      lettersPageSelector.filters.lang !== LangEnum.ALL
    );
  }
);
